import { defineStore } from 'pinia'
import { ref } from 'vue'

const SESSION_STORAGE_KEY = 'X-Session-Id'

/**
 * Session 管理 Store
 */
export const useSessionStore = defineStore('session', () => {
  const sessionId = ref<string | null>(null)

  /**
   * 从 localStorage 初始化 session
   */
  function initSession() {
    const stored = localStorage.getItem(SESSION_STORAGE_KEY)
    if (stored) {
      sessionId.value = stored
    }
  }

  /**
   * 设置 session ID
   */
  function setSessionId(id: string) {
    sessionId.value = id
    localStorage.setItem(SESSION_STORAGE_KEY, id)
  }

  /**
   * 清除 session ID
   */
  function clearSession() {
    sessionId.value = null
    localStorage.removeItem(SESSION_STORAGE_KEY)
  }

  /**
   * 获取 session ID
   */
  function getSessionId(): string | null {
    return sessionId.value
  }

  // 初始化时从 localStorage 读取
  initSession()

  return {
    sessionId,
    setSessionId,
    clearSession,
    getSessionId,
  }
})
